import React, { FC, useState } from 'react'
import { GreenTick, Plus } from '../../../assets';
import { useTranslation } from 'react-i18next';
import { createCn } from '../../../helpers/utils';
import classes from '../styles.module.scss';
import Task from './task.component';
import Modal from '../../../components/modal/modal.component';
import globalClasses from '../../styles.module.scss'
import { toast } from 'react-toastify';
import { NO_PROJECT, useTasks } from '../../../contexts/tasks.context';
import { TaskItem, TaskPriority, TaskStatus } from '../../../services/api.service';

interface IProps {
  status: TaskStatus;
  title: string;
  tasks: TaskItem[];
  /** Выбранная группа доски (NO_PROJECT — задачи без проекта). */
  project: string;
}

const cn = createCn("tasks", classes);

export const PRIORITY_ORDER: TaskPriority[] = ['low', 'medium', 'high', 'urgent'];

const TaskColumn: FC<IProps> = ({ status, title, tasks, project }) => {
  const { t } = useTranslation();
  const { createTask } = useTasks();
  const [open, setOpen] = useState(false);
  const [saving, setSaving] = useState(false);

  const [newTask, setNewTask] = useState({
    title: '',
    dueDate: '',
    description: '',
    priority: 'medium' as TaskPriority,
  });

  const resetForm = () => setNewTask({ title: '', dueDate: '', description: '', priority: 'medium' });

  const handleAddTask = async () => {
    if (!newTask.title.trim() || saving) return;
    setSaving(true);
    try {
      await createTask({
        title: newTask.title.trim(),
        description: newTask.description.trim() || undefined,
        status,
        priority: newTask.priority,
        project: project === NO_PROJECT ? undefined : project,
        due_date: newTask.dueDate ? `${newTask.dueDate}T00:00:00` : undefined,
      });
      resetForm();
      setOpen(false);
      toast(<div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <GreenTick />
        {t('tasks.add-success')}
      </div>)
    } catch (e) {
      toast.error(e instanceof Error ? e.message : t('tasks-board.create-error'));
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className={cn("column")}>
      <div className={cn("column__title")}>
        {title}
        <span className={cn("column__count")}>{tasks.length}</span>
      </div>
      <div className={cn("column__tasks")}>
        {tasks.map((task, index) => (
          <Task key={task.id} task={task} colTitle={title} index={index} />
        ))}
      </div>
      <div className={cn("column__footer")}>
        <button onClick={() => setOpen(!open)} >
          <Plus />
          {t('tasks.add-task')}
        </button>
      </div>

      <Modal
        show={open}
        handleClose={() => setOpen(false)}
        style={{ padding: 0, borderRadius: '1.5rem', minWidth: '25rem' }}
      >
        <div className={cn("add-task-modal")}>
          <div className={cn("add-task-modal__header")}>
            {t('tasks.adding-task')}
          </div>
          <div className={cn("add-task-modal__body")}>
            <div className={globalClasses['form-group']}>
              <label>{t('tasks.task-title')}</label>
              <input
                type="text"
                value={newTask.title}
                onChange={(e) => setNewTask({ ...newTask, title: e.target.value })}
                placeholder={t('tasks.task-title-placeholder') || ''}
              />
            </div>
            <div className={globalClasses['form-group']}>
              <label>{t('tasks.due-date')}</label>
              <input
                type="date"
                value={newTask.dueDate}
                onChange={(e) => setNewTask({ ...newTask, dueDate: e.target.value })}
              />
            </div>
            <div className={globalClasses['form-group']}>
              <label>{t('tasks-board.priority')}</label>
              <select
                value={newTask.priority}
                onChange={(e) => setNewTask({ ...newTask, priority: e.target.value as TaskPriority })}
              >
                {PRIORITY_ORDER.map(p => (
                  <option key={p} value={p}>{t(`tasks-board.priority-${p}`)}</option>
                ))}
              </select>
            </div>
            <div className={globalClasses['form-group']}>
              <label>{t('tasks.description')}</label>
              <textarea
                value={newTask.description}
                onChange={(e) => setNewTask({ ...newTask, description: e.target.value })}
                placeholder={t('tasks.description-placeholder') || ''}
              />
            </div>
          </div>
          <div className={cn("add-task-modal__footer")}>
            <button
              onClick={() => { void handleAddTask() }}
              disabled={!newTask.title.trim() || saving}
            >
              {t('action.add')}
            </button>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default TaskColumn
